import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Super-admin impersonation: when set, backend routes shopkeeper calls to
  // this specific store while keeping the super_admin session intact.
  const impersonateStore = sessionStorage.getItem("qd_impersonate_store");
  if (impersonateStore) config.headers["X-Impersonate-Store"] = impersonateStore;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("qd_token");
      localStorage.removeItem("qd_user");
    }
    return Promise.reject(err);
  }
);
